import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'

export {
  Tab
}

export default Tabs
